//import Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//import Components
import {Button, Row, Col} from 'reactstrap'

//import Styles

const editConfirmButton = ({editing, onConfirm, onRemove, onToggleEditing, }) => {

    const renderEditing = (
        <div>
            <Button
                onClick={
                    () => {
                        onConfirm();
                        onToggleEditing();
                }}
                color='warning'
                size="sm"
                outline
            >
                확인
            </Button>
            <Button
                onClick={onToggleEditing}
                color='danger'
                size="sm"
                outline
            >
                취소
            </Button>
        </div>
    );

    const renderNotEditing = (
        <div>
            <Button
                onClick={onToggleEditing}
                color='warning'
                size="sm"
                outline
            >
                편집
            </Button>
            <Button
                onClick={onRemove}
                color='danger'
                size="sm"
                outline
            >
                삭제
            </Button>
        </div>
    );

    return ( 
        <div>
        {
            editing ? renderEditing : renderNotEditing
        }
        </div>
    );
}

export default editConfirmButton;

editConfirmButton.propTypes = {
    editing: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onToggleEditing: PropTypes.func.isRequired,
}

editConfirmButton.defaultProps = {
    editing : false,
    onConfirm : null,
    onRemove : null,
    onToggleEditing : null
}


// WEBPACK FOOTER //
// ./src/pages/Admin/Components/EditConfirmButton/EditConfirmButton.js